import { createDefaultFilterMap } from '../contexts/defaultFilters';
import {
  type Filter,
  FilterId,
  FilterType,
  type TreeFilter,
} from '../types/filters';
import type { TaxonomyConfig } from '../types/taxonomy';

export const createNonPrimaryParameterFilterMap = (
  taxonomyConfig: TaxonomyConfig
): Map<FilterId, Filter> => {
  // Start from default filters, but ensure none of the primary-filter candidates are marked primary.
  const map = createDefaultFilterMap(undefined, taxonomyConfig);

  const updated = new Map(map);

  [FilterId.COMPANY, FilterId.GEOGRAPHY, FilterId.ROLE].forEach(
    (filterId: FilterId) => {
      const filter = updated.get(filterId);
      if (!filter || filter.type !== FilterType.TREE) return;

      const emptyTree: TreeFilter = {
        ...filter,
        selections: [],
        primarySelections: [],
        isPrimary: false,
      };

      updated.set(filterId, emptyTree);
    }
  );

  return updated;
};
